// extracted by mini-css-extract-plugin
module.exports = {"row":"Admin_row__2sQcn","col":"Admin_col__2SbCU","nav":"Admin_nav__20AIL","item":"Admin_item__2FUkU"};